import { Ref } from "react";

import "./storeSearchMap.scss";

type StoreSearchMapComponentProps = {
    ref?: Ref<HTMLDivElement>;
};

const StoreSearchMapComponent = ({ ref }: StoreSearchMapComponentProps) => {
    return (
        <div className={"store-search-map"}>
            <div
                className="store-search-map__map"
                ref={ref}
            ></div>
        </div>
    );
};

export { StoreSearchMapComponent };
